import { useRef } from 'react'
import { useFrame } from '@react-three/fiber'
import useAppStore from '../stores/appStore'

function Lights() {
  const light1Ref = useRef()
  const light2Ref = useRef()
  const light3Ref = useRef()

  const { audioData, audioPlaying } = useAppStore()

  useFrame((state) => {
    const time = state.clock.getElapsedTime()

    if (light1Ref.current) {
      // Orbit first light
      light1Ref.current.position.x = Math.sin(time * 0.5) * 10
      light1Ref.current.position.z = Math.cos(time * 0.5) * 10

      // React to audio
      if (audioPlaying && audioData.length > 0) {
        const bassAvg = audioData.slice(0, 10).reduce((a, b) => a + b, 0) / 10
        light1Ref.current.intensity = 1.5 + bassAvg * 2
      }
    }

    if (light2Ref.current) {
      // Orbit second light (opposite direction)
      light2Ref.current.position.x = Math.cos(time * 0.3) * 8
      light2Ref.current.position.z = Math.sin(time * 0.3) * 8

      if (audioPlaying && audioData.length > 0) {
        const midAvg = audioData.slice(30, 50).reduce((a, b) => a + b, 0) / 20
        light2Ref.current.intensity = 1.0 + midAvg * 1.5
      }
    }

    if (light3Ref.current) {
      // Gentle bobbing
      light3Ref.current.position.y = Math.sin(time * 0.7) * 3

      if (audioPlaying && audioData.length > 0) {
        const trebleAvg = audioData.slice(80, 120).reduce((a, b) => a + b, 0) / 40
        light3Ref.current.intensity = 0.8 + trebleAvg * 1.2
      }
    }
  })

  return (
    <>
      {/* Ambient base */}
      <ambientLight intensity={0.3} />

      {/* Golden key light */}
      <pointLight
        ref={light1Ref}
        position={[10, 10, 10]}
        intensity={1.5}
        color="#D4AF37"
        distance={50}
        decay={2}
        castShadow
      />

      {/* Complementary fill light */}
      <pointLight
        ref={light2Ref}
        position={[-10, -10, 5]}
        intensity={1.0}
        color="#D4AF37"
        distance={50}
        decay={2}
      />

      {/* Rim light for depth */}
      <pointLight
        ref={light3Ref}
        position={[0, 5, -10]}
        intensity={0.8}
        color="#8B7355"
        distance={40}
        decay={2}
      />

      {/* Directional for overall scene */}
      <directionalLight
        position={[5, 10, 5]}
        intensity={0.5}
        color="#ffffff"
        castShadow
        shadow-mapSize-width={1024}
        shadow-mapSize-height={1024}
      />
    </>
  )
}

export default Lights
